import { AuthApiError } from '@supabase/supabase-js';
import { supabase } from '../lib/supabaseClient';

/**
 * Attempt to recover from authentication failures by refreshing the session.
 * Signs the user out if refresh fails.
 *
 * @param {Error} error - The error thrown by a Supabase call.
 * @param {Function} [signOut] - Optional signOut function from AuthContext.
 * @returns {Promise<boolean>} - Resolves to true if a sign-out occurred.
 */
export async function handleAuthFailure(error, signOut) {
  if (error instanceof AuthApiError || error?.status === 401) {
    try {
      await supabase.auth.refreshSession();
      return false; // Session refreshed successfully
    } catch {
      try {
        if (typeof signOut === 'function') {
          await signOut();
        } else {
          await supabase.auth.signOut();
        }
      } finally {
        // Caller should handle navigation/redirect
      }
      return true; // Sign-out occurred
    }
  }
  return false;
}

export default handleAuthFailure;
